
export { GGUSection } from "/codebuild/output/src3632624141/src/packages/shared-components/src/campaign/GGUSection.tsx"